var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglelarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.27 4.9c1.7 0 3.23.6 4.43 1.6L20.2 3c-2.14-1.85-4.87-3-7.93-3C7.52 0 3.44 2.72 1.5 6.68l4.04 3.1a7.08 7.08 0 0 1 6.74-4.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17 12c0-.78.13-1.53.36-2.23L1.5 6.68a12 12 0 0 0 0 10.63l4.04-3.1A7.1 7.1 0 0 1 5.17 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.27 19.1a7.08 7.08 0 0 1-6.74-4.87L1.5 17.32A11.98 11.98 0 0 0 12.27 24c2.93 0 5.73-1.04 7.83-3l-3.84-2.96a7.43 7.43 0 0 1-3.99 1.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.74 12c0-.7-.1-1.47-.27-2.18h-11.2v4.63h6.45a5.4 5.4 0 0 1-2.46 3.6L20.1 21c2.2-2.05 3.64-5.1 3.64-9.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglelarge);
export default __webpack_public_path__ + "static/media/google.large.0b164d90f7ca159ac82c10d4d93a751b.svg";
export { ForwardRef as ReactComponent };